import { Exception } from '../../common/constants/exception';
import { Invoice } from '../../common/constants/invoice';

export type SubmitGenerateRotpToken = Action<'SUBMIT_GENERATE_ROTP_TOKEN', {invoiceNum: number, invoiceAmt: number, loadNum: number, token: string, recaptchaType: string}>;
export type LoadInvoicePending = Action<'LOAD_INVOICE_PENDING'>;
export type LoadInvoiceSuccess = Action<'LOAD_INVOICE_SUCCESS', {invoices: Invoice[], maxInvoicesLoaded: boolean}>;
export type LoadInvoiceFailure = Action<'LOAD_INVOICE_FAILURE', { error: Exception }>;
export type LoadInvoiceNotFound = Action<'LOAD_INVOICE_NOT_FOUND', { error: Exception }>;
export type LoadInvoiceNotUsd = Action<'LOAD_INVOICE_NOT_USD', { error: Exception }>;
export type LoadInvoiceValidationError = Action<'LOAD_INVOICE_VALIDATION_ERROR', { error: Exception }>;
export type LoadInvoiceForbidden = Action<'LOAD_INVOICE_FORBIDDEN', { error: Exception }>;
export type ResetLoadedInvoice= Action<'RESET_LOADED_INVOICE'>;
export type ReAuthenticate= Action<'RE_AUTHENTICATE'>;

export const submitGenerateRotpToken = (invoiceNum: number, invoiceAmt: number, loadNum: number, token: string, recaptchaType: string) => ({
  type: 'SUBMIT_GENERATE_ROTP_TOKEN',
  payload: { invoiceNum, invoiceAmt, loadNum, token, recaptchaType }
});

export const resetLoadedInvoices = () => ({
  type: 'RESET_LOADED_INVOICE',
});

export const loadInvoicePending = () => ({
  type: 'LOAD_INVOICE_PENDING',
});

export const generateRotpTokenSuccess = () => ({
  type: 'GENERATE_ROTP_TOKEN_SUCCESS'
});

export const loadInvoiceFailure = (error?: Exception) => ({
  type: 'LOAD_INVOICE_FAILURE',
  payload: { error },
});

export const loadInvoiceNotFound = (error?: Exception) => ({
  type: 'LOAD_INVOICE_NOT_FOUND',
  payload: { error },
});

export const loadInvoiceNotUsd = (error?: Exception) => ({
  type: 'LOAD_INVOICE_NOT_USD',
  payload: { error },
});

export const loadInvoiceValidationError = (error?: Exception) => ({
  type: 'LOAD_INVOICE_VALIDATION_ERROR',
  payload: { error },
});

export const loadInvoiceForbidden = (error?: Exception) => ({
  type: 'LOAD_INVOICE_FORBIDDEN',
  payload: { error },
});

export const reAuthenticate = () => ({
  type: 'RE_AUTHENTICATE'
});

export type ActionTypes =
  | SubmitGenerateRotpToken
  | LoadInvoicePending
  | LoadInvoiceSuccess
  | LoadInvoiceFailure
  | LoadInvoiceNotFound
  | LoadInvoiceForbidden
  | ReAuthenticate;
